

























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop } from 'vue-property-decorator'
import FilterButton from '@/modules/common/filter/components/shared/FilterButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { InertiaQueryParamsService } from '@/modules/shared/services/inertia-query-params.service'

@Component({
  components: { BaseInput, FilterButton }
})
export default class FilterRow extends Vue {
  constructor(protected readonly qs: InertiaQueryParamsService) {
    super()
  }

  @Prop() filters!: any

  @Prop({ default: 'جستجوی عنوان یا شناسه آیتم' }) placeholder!: string

  search = this.qs.params.s || ''

  idFilter = true

  @Emit('input')
  updateValue() {

  }

  removeSearch() {
    this.search = ''

    this.updateValue()
  }

  removeId() {
    this.qs.setParamOptimised('id', null)

    this.idFilter = false
  }

  get id() {
    return this.qs.params.id
  }
}
